import { defineMessages } from 'react-intl';

export default defineMessages({
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  whatAreYourExpensesRelatedTo: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.whatAreYourExpensesRelatedTo',
    defaultMessage: 'What are your expenses related to?',
  },
  otherExpenses: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.otherExpenses',
    defaultMessage: 'Other Expenses',
  },
  medicalHospitalExpenses: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.medicalHospitalExpenses',
    defaultMessage: 'Medical & Hospital Expenses',
  },
  wereYouHospitalisedForMoreThanThreeDays: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.wereYouHospitalisedForMoreThanThreeDays',
    defaultMessage: 'Were you hospitalised for more than 3 days?',
  },
  wereYouHospitalisedForMoreThanTenDays: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.wereYouHospitalisedForMoreThanTenDays',
    defaultMessage: 'Were you hospitalised for more than 10 days?',
  },
  periodOfHospitalisation: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.periodOfHospitalisation',
    defaultMessage: 'Period of hospitalisation',
  },
  admissionDate: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.admissionDate',
    defaultMessage: 'Admission Date',
  },
  dischargeDate: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.dischargeDate',
    defaultMessage: 'Discharge Date',
  },
  didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised',
    defaultMessage: 'Did an accompanying person travel from your home country whilst you were hospitalised?',
  },
  cashAllowanceWhileInHospital: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.cashAllowanceWhileInHospital',
    defaultMessage: 'Cash allowance while in hospital',
  },
  accompanyingPersonExpenses: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.accompanyingPersonExpenses',
    defaultMessage: 'Accompanying person expenses',
  },
  expenseFor: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfItem: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  descriptionOfExpense: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  dateOfExpenses: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  amountClaimed: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.currency',
    defaultMessage: 'Currency',
  },

  dentalExpenses: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.dentalExpenses',
    defaultMessage: 'Dental Expenses',
  },
  funeralExpenses: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.funeralExpenses',
    defaultMessage: 'Funeral Expenses',
  },
  expensesArisingFromTerrorism: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.expensesArisingFromTerrorism',
    defaultMessage: 'Expenses arising from terrorism',
  },
  isRequired: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  addItem: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.addItem',
    defaultMessage: 'Add Expense',
  },
  itemWithIdx: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  yes: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.no',
    defaultMessage: 'No',
  },
  opticalTreatment: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.opticalTreatment',
    defaultMessage: 'Optical treatment',
  },
  ancillaryServices: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.ancillaryServices',
    defaultMessage: 'Ancillary services',
  },
  ancillaryServicestTooltip: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.ancillaryServicestTooltip',
    defaultMessage: 'Services provided by registered: acupuncturists, chiropractors, dieticians, osteopaths, physiotherapists, podiatrists, or Chinese medicine practitioners.',
  },
  mentalHealth: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.mentalHealth',
    defaultMessage: 'Mental Health',
  },
  sexualHealth: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.sexualHealth',
    defaultMessage: 'Sexual Health',
  },
  extraTravelAndAccommodation: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.extraTravelAndAccommodation',
    defaultMessage: 'Extra travel and accommodation',
  },
  searchAndRescue: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.searchAndRescue',
    defaultMessage: 'Search and rescue',
  },
  urgentCareOutOfHoursvisits: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.urgentCareOutOfHoursvisits',
    defaultMessage: 'Urgent care / out of hours visits',
  },
  prescriptions: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.prescriptions',
    defaultMessage: 'Prescriptions',
  },
  GPVisits: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.GPVisits',
    defaultMessage: 'GP visits',
  },
  otherMedicalExpenses: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.otherMedicalExpenses',
    defaultMessage: 'Other medical expenses',
  },
  rehabilitationAndOccupationalTherapy: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.rehabilitationAndOccupationalTherapy',
    defaultMessage: 'Rehabilitation and occupational therapy',
  },
  rehabilitationAndOccupationalTherapyTooltip: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.rehabilitationAndOccupationalTherapyTooltip',
    defaultMessage: 'Any registered service provided as treatment or advice related to illness or injury to promote your physical wellbeing and individual dependence.',
  },
  maternityCare: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.maternityCare',
    defaultMessage: 'Maternity care',
  },
  replacementStaff: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.replacementStaff',
    defaultMessage: 'Replacement staff',
  },
  repatriationBenefit: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.repatriationBenefit',
    defaultMessage: 'Repatriation benefit',
  },
  thisSectionRelatedToMedicalExpenses: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.thisSectionRelatedToMedicalExpenses',
    defaultMessage: 'This section relates to medical expenses such as doctor visits, prescriptions, hospitalisation, etc.',
  },
  wasTheDeathCausedByAnInjury: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.wasTheDeathCausedByAnInjury',
    defaultMessage: 'Was the death caused by an injury?',
  },
  lossOfLife: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.lossOfLife',
    defaultMessage: 'Loss of Life',
  },
  selectInsuredForExpense: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.selectInsuredForExpense',
    defaultMessage: 'Select the Insured(s) for the expense',
  },
  amountClaimExceedsMaximumDigits: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountClaimExceedsMaximumDigits',
    defaultMessage: 'Amount Claimed exceeds the maximum allowable digits. Please enter a valid claim amount.',
  },
  descriptionMaxLength: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.descriptionMaxLength',
    defaultMessage: 'Please enter maximum of 150 characters',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/messages.js